



























import { defineComponent, reactive, ref } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import QuestionDetail from '@/components/organisms/questionnaire/QuestionDetail.vue'

import { useUser } from '@/composable/common/useUser'
import useVuex from '@/utils/useVuex'
import { IQuestion } from '@/types/questionnaire'
import { QuestionForm } from '@/composable/questionnaire/useQuestionForm'
import { QuestionnaireActions } from '@/store/questionnaire/actions'
import { useActions } from 'vuex-composition-helpers'

export default defineComponent({
  components: { Layout, QuestionDetail },
  setup(props, context) {
    const root = context.root
    const { user } = useUser(context)
    const pageId = root.$route.params.pageId
    const questionId = root.$route.params.questionId

    const { updateQuestion } = useActions<QuestionnaireActions>(
      'questionnaire',
      ['updateQuestion'],
    )

    const snackbar = ref({
      snackbar: false,
      message: '',
    })

    const state = reactive({
      question: useVuex<IQuestion>(context, () =>
        root.$store.getters['questionnaire/question'](pageId, questionId),
      ),
    })

    const save = async (body: QuestionForm) => {
      try {
        await updateQuestion({ ...body, questionId: parseInt(questionId) })
        root.$router.go(-1)
      } catch {
        snackbar.value.snackbar = true
        snackbar.value.message = 'エラーが発生しました。'
      }
    }

    const cancel = () => {
      const path = context.root.$route.path.replace(
        /page\/\d+\/question\/\d+\/edit/,
        'detail',
      )
      context.root.$router.push(path)
    }

    return { state, snackbar, user, save, cancel }
  },
})
